import _ from 'underscore';
// ActionNames are like these:
// <sliceName>/<label>/<stage>[/<verb>]
// mcaEntity/ENTITY_NAME/START/CREATE
// ccEntity/ENTITY_NAME/START/CREATE
// call/CALL_NAME/START/CALL
// preference/NAME/START/SET
// preference/NAME/START/GET

export const ActionSlices = {
  mcaEntity: 'mcaEntity',
  ccEntity: 'ccEntity',
  externalEntity: 'externalEntity',
  call: 'call',
  preference: 'preference',
};

export const ActionNameSeparator = '/';

export const ActionVerbs = {
  create: 'CREATE',
  read: 'READ',
  update: 'UPDATE',
  destroy: 'DESTROY',
  reset: 'RESET',
  call: 'CALL',

  // for preference
  get: 'GET',
  set: 'SET',
};

export const ActionStages = {
  start: 'START',
  complete: 'COMPLETE',
  fail: 'FAIL',
};

export function createActionName(slice, label, stage, verb) {
  let actionName = [slice, label, stage].join(ActionNameSeparator);

  if (verb) {
    actionName = [actionName, verb].join(ActionNameSeparator);
  }

  return actionName;
}

export function createAction(slice, label, stage, verb) {
  const id = createActionName(slice, label, stage, verb);
  return function actionFn(params) {
    return { type: id, params };
  };
}

export function createMcaEntityAction(entityName, stage, verb) {
  return createAction(ActionSlices.mcaEntity, entityName, stage, verb);
}

export function createCcEntityAction(entityName, stage, verb) {
  return createAction(ActionSlices.ccEntity, entityName, stage, verb);
}

export function createExternalEntityAction(entityName, stage, verb) {
  return createAction(ActionSlices.externalEntity, entityName, stage, verb);
}

export function createCallAction(callName, stage, verb) {
  return createAction(ActionSlices.call, callName, stage, verb);
}

export function createPreferenceAction(preferenceName, stage, verb) {
  return createAction(ActionSlices.preference, preferenceName, stage, verb);
}

export function splitActionName(action) {
  const { type } = action;
  const [slice, label, stage, verb]
    = type.split(ActionNameSeparator);

  return {
    slice,
    label,
    stage,
    verb,
  };
}

// calculate the value diff between newValue and oldValue.
// Will throw error if the oldValue contains keys that are not in newValue
export function calculateValueDiff(oldValue, newValue) {
  const oldKeys = _.keys(oldValue);
  const newKeys = _.keys(newValue);

  const invalidKeys = _.difference(oldKeys, newKeys);

  if (invalidKeys.length > 0) {
    throw new Error(`Invalid keys found: ${invalidKeys.join(', ')}`);
  }

  const diff = {};

  newKeys.forEach((newKey) => {
    if (!_.has(oldValue, newKey) || newValue[newKey] !== oldValue[newKey]) {
      diff[newKey] = newValue[newKey];
    }
  });

  return diff;
}
